import { NgModule } from '@angular/core';
import { NgbModule, NgbPaginationConfig, NgbAccordionConfig, NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload';
import { DndModule } from 'ng2-dnd';
import { CoreModule } from '../core';

import { ConfirmModalComponent } from './components/confirm-modal.component';
import { SmNavMenuComponent } from './components/sm-nav-menu.component';
import { SmFrontendTopMenuComponent } from './components/sm-frontend-top-menu.component';
import { SmBackendTopMenuComponent } from './components/sm-backend-top-menu.component';
import { SmAccountLoginComponent } from './components/sm-account-login.component';
import { SmGlobalSearchComponent } from './components/sm-global-search.component';
import { SmMultiSelectComponent } from './components/sm-multiselect.component';
import { SmSelectComponent } from './components/sm-select.component';
import { SmDateRangeComponent } from './components/sm-date-range.component';
import { SmNumberRangeComponent } from './components/sm-number-range.component';
import { SmPageSizeComponent } from './components/sm-page-size.component';
import { SmFilterComponent } from './components/sm-filter.component';
import { SmFilterControlComponent } from './components/sm-filter-control.component';
import { SmToolbarButtons } from './components/sm-toolbar-buttons.component';
import { SmUploadFileComponent } from './components/sm-upload-file.component';
import { SmBulkActionsComponent, SmLinkBulkActionComponent } from './components/sm-bulk-actions.component';
import { SmImagesEditorComponent } from './components/sm-images-editor.component';
import { SmShipmentComponent } from './components/sm-shipment.component';
import { SmJobreportComponent } from './components/sm-jobreport.component';
import { SmMultiSelectBoxesComponent } from './components/sm-multiselect-boxes.component';
import { SmPaginationComponent } from './components/sm-pagination.component';

import { SmImagePreviewPopoverComponent } from './components/sm-image-preview-popover.component';

import { SmPinDirective, SmPinContainerDirective, SmPinToggleDirective } from './directives/sm-pin.directive';
import { SmScrollDirective } from './directives/sm-scroll.directive';
import { SmFilterControlLabelDirective } from './directives/sm-filter-control-label.directive';
import { SmImagePreviewDirective } from './directives/sm-image-preview.directive';
import { SmOnlyNumbersDirective } from './directives/sm-only-numbers.directive';

import { FilterService } from './services/filter.service';
import { BulkActionService } from './services/bulk-action.service';
import { ExportReportService } from './services/export-report.service';
import { ExportBaseService } from './services/export.service';
import { RelatedActionService } from './services/relatedaction.service';
import { AutomaticImportService } from './services/automatic-import.service';
import { AutomaticExportService } from './services/automatic-export.service';
import { SmAccountService } from './services/account.service';
import { FeedbackTemplateService } from './services/feedback-template.service';
import { CategoryService } from './services/category.service';
import { ConfirmModalService } from './services/confirm-modal.service';
import { LeftMenuStateService } from './services/left-menu-state.service';
import { LeftMenuService } from './services/left-menu.service';
import { NewsService } from './services/news.service';
import { PricelistService } from './services/pricelist.service';
import { TopMenuService } from './services/top-menu.service';
import { TransactionStatusService } from './services/transaction-status.service';

import { MasksFactory } from './format';

import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { SmNgbDatepickerI18n } from './services/sm-ngb-datepicker-i18n';

import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { SmNgbDateParserFormatter } from './services/sm-ngb-date-parser-formatter';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		ReactiveFormsModule,
		FormsModule,
		FileUploadModule,
		NgbModule,
		DndModule,
		CoreModule
	],
	declarations: [
		SmAccountLoginComponent,
		ConfirmModalComponent,
		SmNavMenuComponent,
		SmFrontendTopMenuComponent,
		SmBackendTopMenuComponent,
		SmGlobalSearchComponent,
		SmMultiSelectComponent,
		SmSelectComponent,
		SmDateRangeComponent,
		SmNumberRangeComponent,
		SmPageSizeComponent,
		SmFilterComponent,
		SmFilterControlComponent,
		SmToolbarButtons,
		SmPinContainerDirective,
		SmPinDirective,
		SmPinToggleDirective,
		SmScrollDirective,
		SmFilterControlLabelDirective,
		SmBulkActionsComponent,
		SmLinkBulkActionComponent,
		SmUploadFileComponent,
		SmImagesEditorComponent,
		SmShipmentComponent,
		SmImagePreviewDirective,
		SmOnlyNumbersDirective,
		SmJobreportComponent,
		SmMultiSelectBoxesComponent,
		SmPaginationComponent,
		SmImagePreviewPopoverComponent
	],
	entryComponents: [
		ConfirmModalComponent
	],
	exports: [
		SmAccountLoginComponent,
		ConfirmModalComponent,
		SmNavMenuComponent,
		SmFrontendTopMenuComponent,
		SmBackendTopMenuComponent,
		SmGlobalSearchComponent,
		SmMultiSelectComponent,
		SmSelectComponent,
		SmDateRangeComponent,
		SmNumberRangeComponent,
		SmPageSizeComponent,
		SmFilterComponent,
		SmFilterControlComponent,
		SmToolbarButtons,
		SmPinContainerDirective,
		SmPinDirective,
		SmPinToggleDirective,
		SmScrollDirective,
		SmFilterControlLabelDirective,
		SmBulkActionsComponent,
		SmLinkBulkActionComponent,
		SmUploadFileComponent,
		SmImagesEditorComponent,
		SmShipmentComponent,
		SmImagePreviewDirective,
		SmOnlyNumbersDirective,
		SmMultiSelectBoxesComponent,
		SmPaginationComponent,
		SmImagePreviewPopoverComponent
	],
	providers: [
		NgbPaginationConfig,
		NgbAccordionConfig,
		NgbDropdownConfig,
		ConfirmModalService,
		CategoryService,
		FilterService,
		BulkActionService,
		MasksFactory,
		ExportReportService,
		ExportBaseService,
		AutomaticImportService,
		AutomaticExportService,
		SmAccountService,
		{
			provide: NgbDatepickerI18n,
			useClass: SmNgbDatepickerI18n
		},
		{
			provide: NgbDateParserFormatter,
			useClass: SmNgbDateParserFormatter
		},
		RelatedActionService,
		FeedbackTemplateService,
		LeftMenuService,
		LeftMenuStateService,
		NewsService,
		PricelistService,
		TopMenuService,
		TransactionStatusService
	]
})
export class SharedModule { }


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/shared.module.ts